<script setup lang="ts">
import { useLoginInfoStore } from '~/stores/member/login-info-store'
import { popupHandler } from '~/composables/popup/popup-handler'
import { getImgBaseUrl, isNotEmptyArray } from '~/utils/shop-common'
import type { goodsReview } from '~/types/goods/goods-review'

const { loginDrvtModalOpen } = popupHandler()
const loginInfoStore = useLoginInfoStore()
const { getUserInfo: userInfo } = storeToRefs(loginInfoStore)
const { $filter } = useNuxtApp()

const { reviewData, sortingData } = defineProps<{
  reviewData: goodsReview
  sortingData: object
}>()
const emit = defineEmits<{
  (e: 'successReport'): void
}>()

const reactiveReviewData = reactive(reviewData)
const reactiveSortingData = reactive(sortingData)
/* 상세 Modal */
const { open: openReviewPopup } = useReviewDetailModal(reactiveReviewData, reactiveSortingData, false)
/* 신고 Modal */
function openReviewReport() {
  if (!loginDrvtModalOpen(true)) return
  const { open } = useReviewReportModal(reactiveReviewData, async () => {
    emit('successReport')
  })
  open()
}
</script>

<template>
  <div class="flex items-start justify-between">
    <div class="flex items-center gap-x-2">
      <div class="flex items-center gap-x-[2px]">
        <div class="relative w-[80px] mr-[2px]">
          <div class="flex">
            <template
              v-for="(star, index) of 5"
              :key="index"
            >
              <i-graphic-star-gray class="w-4 h-4" />
            </template>
          </div>
          <div class="absolute top-0 left-0 flex">
            <template
              v-for="(star, index) of Number(reviewData.revScrVal)"
              :key="index"
            >
              <i-graphic-star class="w-4 h-4" />
            </template>
          </div>
        </div>
        <span class="text-14 font-bold">{{ reviewData.revScrVal }}</span>
      </div>
      <span class="divider-horizontal-02 h-3 self-auto" />
      <span class="text-14 text-on-view-03">{{ $filter.scoreMessage(reviewData.revScrVal) }}</span>
    </div>
  </div>
  <span
    v-if="!!reviewData.itmNm"
    class="pt-1 text-14 text-on-view-03"
  >
    {{ reviewData.itmNm }}
  </span>
  <!-- [DEV] 240829 PJ85-12114 - 클래스 수정 -->
  <div
    v-if="isNotEmptyArray(reviewData.evaluations)"
    class="flex flex-wrap gap-1.5 mt-1 py-1.5"
  >
    <div
      v-for="evaluation in reviewData.evaluations"
      :key="evaluation.evltItemNo"
      class="py-2 px-2.5 bg-warm-gray-30 text-14"
    >
      <span class="mr-2 text-on-view-02">{{ evaluation.evltItemNm }}</span>
      <span class="font-medium">{{ evaluation.evltVal }}</span>
    </div>
  </div>
  <!-- [DEV] 240829 PJ85-12114 - 클래스 수정 -->
  <div class="mt-1 text-16 text-on-view-02 break-all">
    <button
      type="button"
      data-gtm-click
      class="text-left"
      :data-gtm-body="useGAHandler().generateGTMData({
        label: '리뷰상세',
      })"
      @click="() => openReviewPopup()"
    >
      {{ reviewData.revCont }}
    </button>
  </div>
  <div
    v-if="isNotEmptyArray(reviewData.contents)"
    class="mt-[10px]"
  >
    <ul class="grid grid-cols-4 gap-x-1 text-[0px]">
      <li
        v-for="photoImg in reviewData.contents?.slice(0, 3)"
        :key="photoImg.contSn"
      >
        <button
          type="button"
          data-gtm-click
          :data-gtm-body="useGAHandler().generateGTMData({
            label: '리뷰상세',
          })"
          @click="() => openReviewPopup()"
        >
          <ShopCommonImage
            :src="getImgBaseUrl(photoImg.contFilePathNm, '160', '160')"
            alt="리뷰 이미지"
          />
        </button>
      </li>
    </ul>
  </div>

  <div class="flex items-center justify-between mt-4">
    <div class="flex items-center gap-x-2">
      <span class="text-14 text-on-view-03">{{ reviewData.member.mbrNm }}</span>
      <span class="divider-horizontal-02 h-3 self-auto" />
      <span class="text-14 text-on-view-03">{{ $filter.yyyyMMdd_dot(reviewData.revWrtDtm) }}</span>
    </div>
    <button
      v-if="userInfo?.mbrNo !== reviewData.member.mbrNo"
      type="button"
      class="btn-link btn-neutral text-14 font-medium"
      data-gtm-click
      :data-gtm-body="useGAHandler().generateGTMData({
        label: '리뷰신고',
      })"
      @click="openReviewReport"
    >
      신고
    </button>
  </div>
</template>

<style scoped>

</style>
